import dayjs from 'dayjs'

/**
 * Formats a date as month name, day and year in the given locale, e.g.
 * "Oct 27, 2026" for `en` and "27 oct 2026" for `es`.
 * @param date Date value to format (`Date | string | null`).
 * @param locale BCP 47 language tag.
 * @returns Formatted date string, or `''` when `date` is null/invalid.
 */
export const formatLocalizedMediumDate = (
  date: Date | string | null,
  locale: string,
): string => {
  const d = dayjs(date)
  return d.isValid()
    ? new Intl.DateTimeFormat(locale, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(d.toDate())
    : ''
}
